
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.synergyindustri.com';

const Seo = ({
  title = 'Synergy — industrial automation, instrumentation and control systems in Ethiopia',
  description = 'Synergy — industrial automation, instrumentation and control systems in Ethiopia. Supplier of PLCs, SCADA, pumps, spare parts and installation services.',
  image = `${SITE_URL}/synergy-social.png`,
  url = SITE_URL,
  keywords = '',
  jsonLd = null,
}) => {
  // Ensure og:image is absolute
  const absoluteImage = image.startsWith('http') ? image : `${SITE_URL}${image.startsWith('/') ? '' : '/'}${image}`;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Canonical and Open Graph URLs */}
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImage} />
      <meta property="og:type" content="website" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImage} />

      {/* JSON-LD structured data */}
      {jsonLd && (
        <script type="application/ld+json" data-seo="true">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default Seo;
